// useContent — lightweight hook to fetch a content KV key with fallback.
// SWR-style: caches responses in-module so multiple components share one fetch.
import { useEffect, useState } from 'react';
import { getAllContent } from '../lib/cmsApi';

let _cache = null;
let _pending = null;
const _subscribers = new Set();

async function _load() {
  if (_cache) return _cache;
  if (!_pending) {
    _pending = getAllContent()
      .then((d) => { _cache = d || {}; _pending = null; _subscribers.forEach((cb) => cb()); return _cache; })
      .catch((_) => { _pending = null; _cache = {}; return _cache; });
  }
  return _pending;
}

export function primeContent() { return _load(); }

export function invalidateContent() {
  _cache = null;
  _pending = null;
  _subscribers.forEach((cb) => cb());
}

export function useContent(key, fallback = null) {
  const [value, setValue] = useState(() => (_cache ? (_cache[key] ?? fallback) : fallback));
  useEffect(() => {
    let cancelled = false;
    const notify = () => { if (!cancelled) setValue(_cache ? (_cache[key] ?? fallback) : fallback); };
    _subscribers.add(notify);
    _load().then(() => { if (!cancelled) notify(); });
    return () => { cancelled = true; _subscribers.delete(notify); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return value;
}
